import $ from 'jquery';

const miHeader = () => {
    // Mega Menu Hover Logic

    // When a top-level item with a dropdown is hovered
    $(document).on('mouseenter', '.elementor-nav-menu--main .elementor-nav-menu > li.menu-item-has-children', function () {
        const $subMenuWrapper = $(this).find('> ul.sub-menu');
        $subMenuWrapper.find('> li').removeClass('is-active-pane');
        $subMenuWrapper.removeClass('has-active-pane');
        $subMenuWrapper.css('min-height', '');
    });

    // When hovering over ANY left-pane item, handle the active right pane
    $(document).on('mouseenter', '.elementor-nav-menu--main .elementor-nav-menu > li > ul.sub-menu > li', function () {
        const $subMenuWrapper = $(this).closest('ul.sub-menu');
        $(this).siblings().removeClass('is-active-pane');

        const $rightPane = $(this).find('> ul.sub-menu');
        if ($(this).hasClass('menu-item-has-children') && $rightPane.length) {
            $(this).addClass('is-active-pane');
            $subMenuWrapper.addClass('has-active-pane');

            // Measure heights dynamically to fit content perfectly without scroll or extra whitespace
            $subMenuWrapper.css('min-height', '');

            const leftHeight = $subMenuWrapper[0].scrollHeight;
            const rightHeight = $rightPane[0].scrollHeight;
            const maxHeight = Math.max(leftHeight, rightHeight);

            if (maxHeight > 0) {
                $subMenuWrapper.css('min-height', maxHeight + 'px');
            }
        } else {
            $subMenuWrapper.removeClass('has-active-pane');
            $subMenuWrapper.css('min-height', '');
        }
    });

    // Clean up when the mouse leaves the top-level menu item completely
    $(document).on('mouseleave', '.elementor-nav-menu--main .elementor-nav-menu > li.menu-item-has-children', function () {
        const $subMenuWrapper = $(this).find('> ul.sub-menu');
        $subMenuWrapper.find('> li').removeClass('is-active-pane');
        $subMenuWrapper.removeClass('has-active-pane');
        $subMenuWrapper.css('min-height', '');
    });
};

const miMobileMenuFix = () => {
    document.addEventListener('click', function (e) {
        const link = e.target.closest('.elementor-nav-menu--dropdown a.has-submenu');
        if (!link) return;

        const isArrow = !!e.target.closest('.sub-arrow');
        const isHash = link.getAttribute('href') === '#';

        if (!isArrow && !isHash) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const $link = $(link);
        const $sub = $link.next('ul.sub-menu');
        const isOpen = $sub.is(':visible');

        $sub.toggle(!isOpen).attr({
            'aria-hidden': isOpen ? 'true' : 'false',
            'aria-expanded': isOpen ? 'false' : 'true'
        });
        $link.attr('aria-expanded', isOpen ? 'false' : 'true');
    }, true);
};

$(function () {
    try {
        miHeader();
        miMobileMenuFix();
    } catch (error) {
        console.warn(error);
    }
});